module.exports = __webpack_public_path__ + "img/firstNFT-logo.c6c25efa.png";